// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class PlanningBudgetApproval {
  readonly id: string;
  readonly plantId: string;
  readonly planningYearId: string;
  readonly approvedBy: string;
  readonly approvedAt: DateTime;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.plantId = data.plantId === undefined ? NIL_UUID : data.plantId;
    this.planningYearId = data.planningYearId === undefined ? NIL_UUID : data.planningYearId;
    this.approvedBy = data.approvedBy === undefined ? NIL_UUID : data.approvedBy;
    this.approvedAt = DateHelpers.ParseServerDateTime(data.approvedAt);
  }

  static zero(): PlanningBudgetApproval {
    const zeroValues: ExcludeMethodsDeep<PlanningBudgetApproval> = {
      id: NIL_UUID,
      plantId: NIL_UUID,
      planningYearId: NIL_UUID,
      approvedBy: NIL_UUID,
      approvedAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
    };
    return new PlanningBudgetApproval(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PlanningBudgetApprovalWireFormat = {
  id: string;
  plantId: string;
  planningYearId: string;
  approvedBy: string;
  approvedAt: string;
};

type NewPlanningBudgetApprovalProps = PartialDeep<
  PlanningBudgetApproval,
  { recurseIntoArrays: true }
>;
export const NewPlanningBudgetApproval: (
  props: NewPlanningBudgetApprovalProps,
) => PlanningBudgetApproval = (props) => new PlanningBudgetApproval(props);

type NewPlanningBudgetApprovalFromWireFormatProps = PartialDeep<
  PlanningBudgetApprovalWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPlanningBudgetApprovalFromWireFormat: (
  props: NewPlanningBudgetApprovalFromWireFormatProps,
) => PlanningBudgetApproval = (props) => new PlanningBudgetApproval(props);
